import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import api from '../Services/api';

const VocabContext = createContext();

export const VocabProvider = ({ children }) => {
    const { user, isAuthenticated } = useAuth();
    const [vertical, setVertical] = useState('school');
    const [collegeType, setCollegeType] = useState('autonomous');
    const [parentUniversity, setParentUniversity] = useState('');
    const [loading, setLoading] = useState(true);
    const [terms, setTerms] = useState({
        program: 'Class/Grade',
        term: 'Academic Year',
        section: 'Section',
        student: 'Student',
        fees: 'Monthly Fees',
        showDualRoll: false
    });

    const fetchVocabConfig = async () => {
        if (!isAuthenticated || !user) {
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            const res = await api.get('education/settings/active/');
            const { vertical_type, college_type, parent_university_name, custom_program_label, custom_term_label, custom_section_label } = res.data;
            
            setVertical(vertical_type || 'school');
            setCollegeType(college_type || 'autonomous');
            setParentUniversity(parent_university_name || '');
            
            if (vertical_type === 'school') {
                setTerms({
                    program: custom_program_label || 'Class/Grade',
                    term: custom_term_label || 'Academic Year',
                    section: custom_section_label || 'Section',
                    student: 'Student',
                    fees: 'Monthly Fees',
                    showDualRoll: false
                });
            } else if (vertical_type === 'college') {
                setTerms({
                    program: custom_program_label || 'Course/Degree',
                    term: custom_term_label || 'Semester',
                    section: custom_section_label || 'Branch/Batch',
                    student: 'Student',
                    fees: 'Semester Tuition',
                    showDualRoll: college_type === 'affiliated',
                    parentUniversity: parent_university_name
                });
            } else if (vertical_type === 'university') {
                setTerms({
                    program: custom_program_label || 'Course/Degree',
                    term: custom_term_label || 'Semester',
                    section: custom_section_label || 'Branch/Batch',
                    student: 'Student',
                    fees: 'Semester Tuition',
                    showDualRoll: false
                });
            } else if (vertical_type === 'coaching') {
                setTerms({
                    program: custom_program_label || 'Target Program',
                    term: custom_term_label || 'Batch Cycle',
                    section: custom_section_label || 'Study Slot',
                    student: 'Aspirant',
                    fees: 'Program Fees',
                    showDualRoll: false
                });
            }
        } catch (err) {
            console.error("Vocabulary initialization failed, using defaults:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVocabConfig();
    }, [isAuthenticated, user]);

    return (
        <VocabContext.Provider value={{ vertical, collegeType, parentUniversity, terms, fetchVocabConfig, loading }}>
            {children}
        </VocabContext.Provider>
    );
};

export const useVocab = () => useContext(VocabContext);
